import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, Button, Divider } from "@mui/material";
import "../css/Pricing.css";
import Header from "../Common/Header";
import Footer from "../Common/Footer";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PhoneIcon from "@mui/icons-material/Phone";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SyncIcon from "@mui/icons-material/Sync";
import LockIcon from "@mui/icons-material/Lock";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import Faq from "../Common/Faq";
const dummyPlans = {
  CRM: { business: "CRM Business Plan", individual: "CRM Individual Plan" },
  ERP: { business: "ERP Business Plan", individual: "ERP Individual Plan" },
  Sales: {
    business: "Sales Business Plan",
    individual: "Sales Individual Plan",
  },
  Marketing: {
    business: "Marketing Business Plan",
    individual: "Marketing Individual Plan",
  },
};

function PricingCard({ title, features, price }) {
  return (
    <div className="pricing-plan-card">
      <h3 className="pricing-plan-title">{title}</h3>
      <ul className="pricing-plan-features">
        {features.map((feature, idx) => (
          <li key={idx}>✅ {feature}</li>
        ))}
      </ul>
      <div className="pricing-plan-price">US${price}/mo</div>
      <Button
        variant="contained"
        className="pricing-btn-join"
        endIcon={<AddCircleOutlineIcon />}
      >
        Join Now
      </Button>
    </div>
  );
}

function Pricing() {
  const [selectedProduct, setSelectedProduct] = useState("ERP");
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_, newValue) => setTabValue(newValue);

  const dummyPlans = {
    CRM: {
      business: {
        basic: {
          title: "🚀 CRM Starter",
          price: 0,
          features: [
            "Up to 5 CRM users",
            "Basic lead tracking",
            "Email notifications",
            "Standard dashboard",
            "Email support",
          ],
        },
        pro: {
          title: "💼 CRM Pro",
          price: 0,
          features: [
            "Unlimited CRM users",
            "Sales pipeline automation",
            "Lead management",
            "Priority CRM support",
            "Custom dashboard views",
            "API access",
          ],
        },
      },
      individual: {
        basic: {
          title: "🚀 CRM Individual Basic",
          price: 0,
          features: ["3 user limit", "Email support", "Basic analytics"],
        },
        pro: {
          title: "💼 CRM Individual Pro",
          price: 0,
          features: ["10 user limit", "Advanced reports", "Priority support"],
        },
      },
    },
    ERP: {
      business: {
        basic: {
          title: "🚀 ERP Starter",
          price: 0,
          features: [
            "Up to 5 users",
            "Inventory tracking",
            "Standard reporting",
            "Email support",
          ],
        },
        pro: {
          title: "💼 ERP Business Pro",
          price: 0,
          features: [
            "Unlimited team members",
            "Advanced workflows",
            "Inventory & billing",
            "Multi-branch support",
            "Priority support",
          ],
        },
      },
      individual: {
        basic: {
          title: "🚀 ERP Individual Basic",
          price: 0,
          features: ["Single user", "Standard templates", "Email support"],
        },
        pro: {
          title: "💼 ERP Individual Pro",
          price: 0,
          features: ["Multi-user access", "Custom reports", "Priority support"],
        },
      },
    },
    Sales: {
      business: {
        basic: {
          title: "🚀 Sales Starter",
          price: 0,
          features: [
            "Basic sales reporting",
            "Lead follow-up alerts",
            "Email templates",
          ],
        },
        pro: {
          title: "💼 Sales Pro",
          price: 0,
          features: [
            "Unlimited sales agents",
            "Sales analytics",
            "Lead conversion tracking",
            "Commission management",
          ],
        },
      },
      individual: {
        basic: {
          title: "🚀 Sales Basic",
          price: 0,
          features: ["Lead tracking", "Alerts", "Standard dashboard"],
        },
        pro: {
          title: "💼 Sales Pro",
          price: 0,
          features: [
            "Advanced analytics",
            "Follow-up workflows",
            "Priority support",
          ],
        },
      },
    },
    Marketing: {
      business: {
        basic: {
          title: "🚀 Marketing Basic",
          price: 0,
          features: [
            "Email campaign builder",
            "Basic analytics",
            "Standard templates",
          ],
        },
        pro: {
          title: "💼 Marketing Suite",
          price: 0,
          features: [
            "Campaign automation",
            "Multi-channel tracking",
            "Email marketing",
            "Performance insights",
          ],
        },
      },
      individual: {
        basic: {
          title: "🚀 Marketing Individual Basic",
          price: 0,
          features: ["1 campaign/mo", "Email support", "Basic templates"],
        },
        pro: {
          title: "💼 Marketing Individual Pro",
          price: 0,
          features: [
            "Unlimited campaigns",
            "Automation",
            "Analytics dashboard",
          ],
        },
      },
    },
  };

  const products = Object.keys(dummyPlans);

  return (
    <>
      <Header />
      <div className="pricing-wrapper">
        <div className="pricing-sidebar">
          {products.map((prod) => (
            <div
              key={prod}
              className={`pricing-sidebar-item ${
                selectedProduct === prod ? "active" : ""
              }`}
              onClick={() => setSelectedProduct(prod)}
            >
              {prod}
            </div>
          ))}
        </div>

        <div className="pricing-content">
          <h2 className="pricing-heading">✨ Plans That Scale With You</h2>

          <Tabs
            style={{ justifyContent: "center" }}
            value={tabValue}
            onChange={handleTabChange}
            className="pricing-tab-root"
          >
            <Tab label="For Business And Enterprises" className="pricing-tab" />
            <Tab label="For Individual" className="pricing-tab" />
          </Tabs>

          <div className="pricing-cards">
            {tabValue === 0 && (
              <>
                <PricingCard
                  title={dummyPlans[selectedProduct].business.basic.title}
                  features={dummyPlans[selectedProduct].business.basic.features}
                  price={dummyPlans[selectedProduct].business.basic.price}
                />
                <PricingCard
                  title={dummyPlans[selectedProduct].business.pro.title}
                  features={dummyPlans[selectedProduct].business.pro.features}
                  price={dummyPlans[selectedProduct].business.pro.price}
                />
              </>
            )}
            {tabValue === 1 && (
              <>
                <PricingCard
                  title={dummyPlans[selectedProduct].individual.basic.title}
                  features={
                    dummyPlans[selectedProduct].individual.basic.features
                  }
                  price={dummyPlans[selectedProduct].individual.basic.price}
                />
                <PricingCard
                  title={dummyPlans[selectedProduct].individual.pro.title}
                  features={dummyPlans[selectedProduct].individual.pro.features}
                  price={dummyPlans[selectedProduct].individual.pro.price}
                />
              </>
            )}
          </div>
        </div>
      </div>

      <div className="pricing-help-section">
        <div className="pricing-help-header">
          <h2>Need Help Choosing the Right Plan? Let’s Talk!</h2>
          <p>
            Still not sure which plan fits your needs? Our team is just a call
            away. Whether you’re a solo professional or managing a growing
            business, we’ll help you understand your options, answer your
            questions, and guide you to the best solution for your workflow. No
            pressure — just honest advice.
          </p>

          <div className="pricing-help-phone">
            <PhoneIcon className="phone-icon" />
            <span>+91 84271-84549</span>
          </div>
        </div>

        <div className="pricing-help-features">
          <div className="prcing-help-container">
            <h3>Top Features You Get With Every Plan</h3>
            <div className="pricing-feature-cards">
              <div className="feature-card blue-border">
                <h4>Real-Time Sync</h4>
                <p>
                  All changes update instantly across your team and devices, no
                  delays.
                </p>
                <SyncIcon className="feature-icon" />
              </div>

              <div className="feature-card red-border">
                <h4>Secure & Reliable</h4>
                <p>
                  data is protected with enterprise-grade security and regular
                  backups.
                </p>
                <LockIcon className="feature-icon" />
              </div>

              <div className="feature-card yellow-border">
                <h4>24/7 Support</h4>
                <p>
                  Get help anytime with our dedicated support team via chat,
                  email, or call.
                </p>
                <SupportAgentIcon className="feature-icon" />
              </div>

              <div className="feature-card green-border">
                <h4>Easy to Scale</h4>
                <p>
                  Start small and upgrade anytime as your business grows — no
                  downtime, no hassle.
                </p>
                <TrendingUpIcon className="feature-icon" />
              </div>
            </div>
          </div>
        </div>
        <div className="pricing-help-actions">
          <Button variant="contained" className="pricing-btn-start">
            Get Started Now
          </Button>
          <Button
            variant="outlined"
            className="pricing-btn-contact"
            startIcon={<PhoneIcon />}
          >
            Contact Now
          </Button>
          <h2 className="pricing-journey-text">Start Your Journey Now!</h2>
        </div>
      </div>

      <Faq />
      <Footer />
    </>
  );
}

export default Pricing;
